module.exports = __webpack_public_path__ + "static/media/Annie.718f8a50.png";